import React from 'react';
import { Section, FadeIn } from './ui';
import { Check, X } from 'lucide-react';
export const AudienceSection = () => {
  const isForYou = ['Eres mujer entre 30 y 60 años', 'Sientes que das más de lo que recibes', 'Te cuesta poner límites sin sentirte mal', 'Has perdido el contacto con quien eras antes', 'Tu cuerpo ya te está mandando señales', 'Quieres cambiar pero no sabes por dónde empezar', 'Mereces apoyo pero no sabes cómo pedirlo'];
  const isNotForYou = ['Buscas frases motivacionales vacías', 'No estás dispuesta a ser honesta contigo misma', 'Quieres resultados sin ningún esfuerzo'];
  return <Section className="bg-cream-100" data-id="element-18">
      <FadeIn data-id="element-19">
        <h2 className="text-2xl sm:text-4xl font-serif text-center text-navy-900 mb-8 sm:mb-16" data-id="element-20">
          Para Quién es Este Libro
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8" data-id="element-21">
          <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm border border-green-100" data-id="element-22">
            <h3 className="text-xl sm:text-2xl font-serif text-navy-900 mb-4 sm:mb-6 border-b pb-3 sm:pb-4" data-id="element-23">
              Este libro ES para ti si...
            </h3>
            <ul className="space-y-2 sm:space-y-4" data-id="element-24">
              {isForYou.map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-25">
                  <div className="mt-1 bg-green-100 text-green-600 rounded-full p-1 shrink-0" data-id="element-26">
                    <Check size={14} strokeWidth={3} data-id="element-27" />
                  </div>
                  <span className="text-gray-700 text-sm sm:text-lg" data-id="element-28">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm border border-rose-100" data-id="element-29">
            <h3 className="text-xl sm:text-2xl font-serif text-navy-900 mb-4 sm:mb-6 border-b pb-3 sm:pb-4" data-id="element-30">
              Este libro NO es para ti si...
            </h3>
            <ul className="space-y-2 sm:space-y-4" data-id="element-31">
              {isNotForYou.map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-32">
                  <div className="mt-1 bg-rose-100 text-rose-600 rounded-full p-1 shrink-0" data-id="element-33">
                    <X size={14} strokeWidth={3} data-id="element-34" />
                  </div>
                  <span className="text-gray-700 text-sm sm:text-lg" data-id="element-35">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </FadeIn>
    </Section>;
};